export function getUniqueArray<T = unknown>(array: T[]): T[] {
  if (!Array.isArray(array)) {
    return array;
  }

  const result = new Set<T>();

  array.forEach((item: T) => {
    switch (true) {
      case (item === undefined):
      case (item === null):
      case (typeof item === 'number'):
      case (typeof item === 'string'):
      case (typeof item === 'boolean'): {
        if (result.has(item)) {
          return;
        }

        result.add(item);
        break;
      }
      case (typeof item === 'function'): {
        const existentFunctions = [...result.values()]
          .filter(Boolean)
          .filter((uniqueItem: T) => typeof uniqueItem === 'function');

        const doesFunctionExist = existentFunctions
          .some((uniqueFunction: T) => item.toString() === uniqueFunction.toString());

        if (doesFunctionExist) {
          return;
        }

        result.add(item);
        break;
      }
      default: {
        const existentItems = [...result.values()]
          .filter(Boolean)
          .filter((uniqueItem: T) => !['number', 'string', 'boolean', 'function'].includes(typeof uniqueItem));

        const doesItemExist = existentItems
          .some((uniqueItem: T) => JSON.stringify(item) === JSON.stringify(uniqueItem));

        if (doesItemExist) {
          return;
        }

        result.add(item);
      }
    }
  });

  return [...result];
}
